import { render, staticRenderFns } from "./RegisterCliente.vue?vue&type=template&id=63d18518&"
import script from "./RegisterCliente.vue?vue&type=script&lang=js&"
export * from "./RegisterCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports